/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ExecutionResponse = {
    id?: number;
    sequence?: number;
    leftVariableId?: number;
    operator?: ExecutionResponse.operator;
    rightVariableId?: number;
    rightValue?: string;
};

export namespace ExecutionResponse {

    export enum operator {
        PLUS = 'PLUS',
        MINUS = 'MINUS',
        TIMES = 'TIMES',
        DIVIDEDBY = 'DIVIDEDBY',
        ASSIGN = 'ASSIGN',
    }


}

